module.exports = __webpack_public_path__ + "media/images/vod_icons/purebarre-eda8fbf458304876a0d7533ecea08935.svg";